/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { Link } from "react-router-dom";
// material react table
import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx";
//api url requirement
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";
//import context
import { GlobalProvider } from "context/GlobalContext";
//import translation function for language translation
import { useTranslation } from "react-i18next";

const FIELD_TO_PARAM = {
  title: "title",
  owner: "owner",
  projectstartdate: "projectstartdate",
  projectenddate: "projectenddate",
  tagstring: "tagstring",
};

const ProjectList = ({
  downloadExcel,
  search,
  setRecords,
  checkedRecordCount,
}) => {
  const token = localStorage.getItem("token"); // token
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const { t } = useTranslation(); //for translation
  const {
    reloadProjectList,
    setreloadProjectList,
    seteditProjectId,
    filterDateRange,
    filterTitle,
    filterTags,
    screenHeight,
  } = useContext(GlobalProvider);
  const [projectList, setProjectList] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterTimer = useRef(null);

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return projectList.filter((item) => selectedIds.includes(item._id));
  };

  /* Excel export */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : projectList;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Project.xlsx");
  };

  /* function to get all label data */
  const getAllProjectList = async (currentColumnFilters = columnFilters) => {
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_PROJECTS +
        `?token=${token}&userrolestring=${userInfo.role.name}`;
      requestUrl +=
        filterDateRange != "" ? `&filterdates=${filterDateRange}` : "";
      if (filterTitle != "") {
        requestUrl = requestUrl + `&filtertitle=${filterTitle}`;
      }
      if (filterTags.length > 0) {
        requestUrl = requestUrl + `&filtertags=${filterTags}`;
      }
      currentColumnFilters.forEach(({ id, value }) => {
        const param = FIELD_TO_PARAM[id];
        if (param && value?.toString().trim()) {
          requestUrl += `&${param}=${encodeURIComponent(value.toString().trim())}`;
        }
      });
      console.log("project list url =====>>>", requestUrl);
      const response = await getData(requestUrl);
      console.log("project list response ========>>>", response);
      if (response.data) {
        setProjectList(response.data);
        setResponseReceived(true);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  /* custom title html */
  const titleHtml = ({ dataItem }) => {
    return (
      <div className="title">
        <div className="d-flex align-items-center gap-2">
          <span>{dataItem.title}</span>
          <Link
            to="#addUpdateProjectPopup"
            data-bs-toggle="offcanvas"
            className="ml-auto edit_icon"
          >
            <span
              className="d-block material-symbols-outlined icon-md"
              onClick={() => {
                seteditProjectId(dataItem._id);
              }}
            >
              edit
            </span>
          </Link>
        </div>
      </div>
    );
  };
  useEffect(() => {
    if (filterDateRange != "" || filterTitle != "" || filterTags.length > 0) {
      getAllProjectList();
    }
  }, [filterDateRange, filterTitle, filterTags]);
  /* hook to reload list */
  useEffect(() => {
    if (reloadProjectList || !responseReceived) {
      getAllProjectList();
      if (reloadProjectList) {
        setreloadProjectList(false);
      }
    }
  }, [reloadProjectList, responseReceived]);
  /* hook to hit  exportExcel() function*/
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);
  /* hook to hit filterData function on search */
  useEffect(() => {
    filterData();
  }, [search]);
  /* set records when projectList changes */
  useEffect(() => {
    setRecords(projectList.length);
  }, [projectList]);

  const tableColumns = useMemo(
    () => [
      {
        id: "title",
        accessorKey: "title",
        header: t("Title"),
        Cell: ({ row }) => titleHtml({ dataItem: row.original }),
        size: 200,
      },
      {
        id: "owner",
        accessorKey: "owner",
        header: t("Moderator"),
        size: 200,
      },
      {
        id: "projectstartdate",
        accessorKey: "projectstartdate",
        header: t("Start Date"),
        size: 200,
      },
      {
        id: "projectenddate",
        accessorKey: "projectenddate",
        header: t("End Date"),
        size: 200,
      },
      {
        id: "tagstring",
        accessorKey: "tagstring",
        header: t("Labels"),
        size: 200,
      },
    ],
    [projectList]
  );

  useEffect(() => {
    if (filterDateRange != "" || filterTitle != "" || filterTags.length > 0) {
      getAllProjectList();
    }
  }, [filterDateRange, filterTitle, filterTags]);

  /* hook to reload list */
  useEffect(() => {
    if (reloadProjectList || !responseReceived) {
      getAllProjectList();
      if (reloadProjectList) {
        setreloadProjectList(false);
      }
    }
  }, [reloadProjectList, responseReceived]);

  /* hook to hit exportExcel() function */
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* set records when projectList changes */
  useEffect(() => {
    setRecords(projectList.length);
  }, [projectList]);

  /* column filter — debounced API call */
  useEffect(() => {
    clearTimeout(columnFilterTimer.current);
    columnFilterTimer.current = setTimeout(() => {
      getAllProjectList(columnFilters);
    }, 500);
  }, [columnFilters]);

  /* sync selected count to parent */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, projectList]);

  return (
    <div className="table-responsive">
      <MaterialReactTable
        columns={tableColumns}
        data={projectList}
        enableSorting
        enableFilters
        enableGlobalFilter={false}
        manualFiltering
        enableGrouping
        enableColumnOrdering
        enableStickyHeader
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        onColumnFiltersChange={setColumnFilters}
        getRowId={(row) => row._id}
        state={{ rowSelection, columnFilters }}
        muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
        muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
        muiTableBodyProps={{ sx: { overflow: "visible" } }}
        initialState={{
          pagination: { pageSize: 100, pageIndex: 0 },
          showColumnFilters: true,
        }}
      />
    </div>
  );
};
export default ProjectList;
